import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index/index'
import abouts from '@/components/abouts/index'

import news from '@/components/news/index'
import product from '@/components/product/index'
import comment from '@/components/comment/index'
import detail from '@/components/detail/index'
import detail1 from '@/components/detail/index1'
import caseList from '@/components/case/index'

Vue.use(Router)

// //获取原型对象上的push函数
// const originalPush = Router.prototype.push
// //修改原型对象中的push方法
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '/',
      component: index
    },
    {
      path: '/pages/contact/index',
      name: '/pages/contact/index',
      component: abouts
    },
    {
      path: '/pages/news/index',
      name: '/pages/news/index',
      component: news
    },
    {
      path: '/pages/news/detail',
      name: '/pages/news/detail',
      component: detail
    },
    {
      path: '/pages/case/detail',
      name: '/pages/case/detail',
      component: detail1
    },
    {
      path: '/pages/case/index',
      name: '/pages/case/index',
      component: caseList
    },

    
    {
      path: '/pages/service/index',
      name: '/pages/service/index',
      component: product
    },
    {
      path: '/pages/service/sub',
      name: '/pages/service/sub',
      component: comment
    },
    // {
    //   path: '/cases',
    //   name: 'cases',
    //   component: cases
    // },
    // {
    //   path: '/contact',
    //   name: 'contact',
    //   component: contact
    // },
    // {
    //   path: '/newsList',
    //   name: 'newsList',
    //   component:newsList
    // },
    // {
    //   path: '/informList',
    //   name: 'informList',
    //   component:informList
    // },
    // {
    //   path: '/detail',
    //   name: 'detail',
    //   component:detail
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js